import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailComponent } from './email.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from '../select/select.module';
import { FormDirectivesModule } from '../../directives/form-directives.module';
import { PipeModule } from 'src/app/shared/pipe.module';

@NgModule({
  declarations: [EmailComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RippleModule,
    InputTextModule,
    InputNumberModule,
    ButtonModule,
    DropdownModule,
    SelectModule,
    FormDirectivesModule,
    PipeModule,
  ],
  exports: [EmailComponent],
})
export class EmailModule {}
